export const compareAddresses = (a, b) => a.toLowerCase() === b.toLowerCase();
